import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logoFreelaDash from "@/assets/logo-freeladash.png";

export function LandingFooter() {
  return (
    <footer className="relative bg-card border-t border-border py-12">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Logo & Description */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="md:col-span-1"
          >
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src={logoFreelaDash}
                alt="FreelaDash - Gestão para Freelancers"
                className="h-8 w-8 rounded-lg object-contain"
                loading="lazy"
              />
              <span
                className="font-display text-xl font-bold tracking-wide text-primary"
                style={{ WebkitTextStroke: "0.5px currentColor" }}
              >
                FREELADASH
              </span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Sistema completo de gestão para freelancers. Seu tempo vale dinheiro.
            </p>
          </motion.div>

          {/* Product Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Produto</h3>
            <nav className="flex flex-col gap-2 text-sm" aria-label="Links do produto">
              <Link
                to="/signup"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Testar Grátis
              </Link>
              <Link
                to="/login"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Entrar
              </Link>
              <a
                href="#pricing"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Preços
              </a>
            </nav>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Recursos</h3>
            <nav className="flex flex-col gap-2 text-sm" aria-label="Links de recursos">
              <a
                href="#demo"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Como Funciona
              </a>
              <a
                href="#faq"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                FAQ
              </a>
              <a
                href="mailto:jmkoygg@gmail.com"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Suporte
              </a>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Legal</h3>
            <nav className="flex flex-col gap-2 text-sm" aria-label="Links legais">
              <Link
                to="/termos"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Termos de Uso
              </Link>
              <Link
                to="/privacidade"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Política de Privacidade
              </Link>
              <Link
                to="/cancelamento"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Cancelamento
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} FreelaDash. Todos os direitos reservados.
          </p>
          <p className="text-xs text-muted-foreground">
            Feito com 💙 para freelancers brasileiros
          </p>
        </div>
      </div>
    </footer>
  );
}
